import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {EntityLinkedToAccountWithAuditMetadataConverter} from '../../../../../common/converter/entityLinkedToAccountWithAuditMetadata.converter';
import {AgendaCalendarModel} from '../entity/agendaCalendar.model';
import {Injectable} from '@angular/core';
import {UserSummaryConverter} from '../../../../../account/modules/user/api/converter/userSummary.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {OfficeSummaryConverter} from '../../../../../office/api/model/converter/officeSummary.converter';
import {AgendaCalendarSummaryConverter} from "./agendaCalendarSummary.converter";

@Injectable({providedIn: 'root'})
export class AgendaCalendarConverter extends HttpModelConverter<AgendaCalendarModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private officeSummaryConverter: OfficeSummaryConverter,
                private entityLinkedToAccountWithAuditMetadataConverter: EntityLinkedToAccountWithAuditMetadataConverter,
                private summaryConverter: AgendaCalendarSummaryConverter) {
        super();
    }

    protected createInstance(): AgendaCalendarModel {
        return new AgendaCalendarModel();
    }

    protected enrichObject(result: AgendaCalendarModel, src: AgendaCalendarModel) {
        this.entityLinkedToAccountWithAuditMetadataConverter.convert(result, src);
        result.summary = this.summaryConverter.convert(src.summary);
        result.office = this.officeSummaryConverter.convert(result.office);
        result.owner = new UserSummaryConverter().convert(result.owner);
        result.type = this.lovValueSummaryConverter.convert(result.type);
    }
}
